import { render, staticRenderFns } from "./rfp-responses.vue?vue&type=template&id=0b216944&scoped=true&"
import script from "./rfp-responses.vue?vue&type=script&lang=js&"
export * from "./rfp-responses.vue?vue&type=script&lang=js&"
import style0 from "./rfp-responses.vue?vue&type=style&index=0&id=0b216944&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b216944",
  null
  
)

export default component.exports